import {
  wappCommunicateCoreGetNotifications,
  WAPP_COMMUNICATE_CORE_GET_NOTIFICATIONS,
  WAPP_COMMUNICATE_CORE_SEND_NOTIFICATION,
  WAPP_COMMUNICATE_CORE_SEND_NOTIFICATION_TO_ADMINS,
  WAPP_COMMUNICATE_CORE_DELETE_NOTIFICATION,
} from '@weblite/wapp-communication-action/core'
import { sendOldActionToWapp } from '../wapp-communication.publish'
import { wappSub } from '$helper/functions/subscription'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_NOTIFICATIONS,
  ({ meta }) => {
    sendOldActionToWapp(wappCommunicateCoreGetNotifications([]), meta)
  },
  true,
)

wappSub.subscribe(WAPP_COMMUNICATE_CORE_SEND_NOTIFICATION, () => {}, true)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_SEND_NOTIFICATION_TO_ADMINS,
  () => {},
  true,
)

wappSub.subscribe(WAPP_COMMUNICATE_CORE_DELETE_NOTIFICATION, () => {}, true)
